import React from 'react'

type Props = {
  steps: number
  current: number
}

export default function ProgressBar({ steps, current }: Props) {
  return (
    <nav className="flex items-center justify-center" aria-label="Progress">
      <p className="text-sm font-medium">Step {current + 1}</p>
      <ol role="list" className="ml-8 flex items-center space-x-5">
        {Array.from({ length: steps }, (x, i) => i).map((_, idx) => (
          <li key={idx}>
            {idx < current && (
              <div className="block h-2.5 w-2.5 rounded-full bg-blue-600"></div>
            )}
            {idx == current && (
              <div
                className="relative flex items-center justify-center"
                aria-current="step"
              >
                <span className="absolute flex h-5 w-5 p-px" aria-hidden="true">
                  <span className="h-full w-full rounded-full bg-blue-200" />
                </span>
                <span
                  className="relative block h-2.5 w-2.5 rounded-full bg-blue-600"
                  aria-hidden="true"
                />
              </div>
            )}
            {idx > current && (
              <div className="block h-2.5 w-2.5 rounded-full bg-gray-200" />
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
